import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const getAddressSlice = createApi({
    reducerPath: "getAddress",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        getAddress: builder.query({
            query: (data) => ({ url: "/inventory/api/v1/address/detail", params: data, method: "GET" }),
        }),
    }),
});

export const { useGetAddressQuery } = getAddressSlice;
